"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseStatus = void 0;
exports.instanceOfLicenseStatus = instanceOfLicenseStatus;
exports.LicenseStatusFromJSON = LicenseStatusFromJSON;
exports.LicenseStatusFromJSONTyped = LicenseStatusFromJSONTyped;
exports.LicenseStatusToJSON = LicenseStatusToJSON;
exports.LicenseStatusToJSONTyped = LicenseStatusToJSONTyped;
/**
 *
 * @export
 */
exports.LicenseStatus = {
    Unverified: 'UNVERIFIED',
    Verified: 'VERIFIED',
    Exception: 'EXCEPTION'
};
function instanceOfLicenseStatus(value) {
    for (const key in exports.LicenseStatus) {
        if (Object.prototype.hasOwnProperty.call(exports.LicenseStatus, key)) {
            if (exports.LicenseStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function LicenseStatusFromJSON(json) {
    return LicenseStatusFromJSONTyped(json, false);
}
function LicenseStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function LicenseStatusToJSON(value) {
    return value;
}
function LicenseStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=LicenseStatus.js.map